import type { Conversation } from 'entities/Conversation'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { isOptOutCurrentInbox } from 'entities/Contacts'

export const hasOptOutFilter = (conversation: Conversation, entities: IEntitiesStore) => {
  return Boolean(
    conversation.contact?.isOptOut ||
      isOptOutCurrentInbox({
        contact: conversation.contact,
        conversation: conversation,
        entities: entities,
      })
  )
}
